<template>
  <span v-if="isEmpty" data-id="cipRiskLevelChip">{{ text }}</span>
  <span
    v-else
    class="cip-risk-chip"
    :style="{ backgroundColor: colors.background, color: colors.text }"
    data-id="cipRiskLevelChip"
  >
    <span
      class="cip-risk-chip-dot"
      :style="{ backgroundColor: colors.text }"
    ></span>
    {{ text }}
  </span>
</template>

<script>
// Palette and shape are mandated by the CIP designs. Shared by the participant worksheet and
// the order-line queues so a tier looks the same wherever it appears.
const palettes = {
  Low: { background: "#E8F3EC", text: "#2E7D32" },
  Medium: { background: "#FDEFE4", text: "#BC621E" },
  High: { background: "#FAE6E6", text: "#D32F2F" },
  Pending: { background: "#EEEEEE", text: "#616161" },
  Error: { background: "#EEEEEE", text: "#616161" },
};

const levelLabels = { low: "Low", medium: "Medium", high: "High" };

const emptyLabel = "—";

export default {
  props: {
    // The tier: "low", "medium" or "high".
    level: {
      type: String,
      default: null,
    },
    // The assessment's lifecycle status; only the worksheet passes it.
    status: {
      type: String,
      default: null,
    },
  },

  computed: {
    text: function () {
      if (this.status === "pending") return "Pending";
      if (this.status === "error") return "Error";
      return levelLabels[this.level] || emptyLabel;
    },

    isEmpty: function () {
      return this.text === emptyLabel;
    },

    colors: function () {
      return palettes[this.text] || palettes.Pending;
    },
  },
};
</script>

<style lang="scss" scoped>
.cip-risk-chip {
  display: inline-flex;
  align-items: center;
  // 4px + 16px line-height + 4px = the 24px chip height of the design.
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
}

.cip-risk-chip-dot {
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  margin-right: 8px;
  flex-shrink: 0;
}
</style>
